export default __webpack_public_path__ + "static/media/delete.368d7b5c.svg";